import { create } from "zustand";
import { FieldType } from "../components/AdditionalMeetingFields";

interface IUseAdditionalFieldsStore {
  fields: FieldType[];
  append: any;
  remove: any;
  update: any;
  setMethods: (fields: FieldType[], append: any, remove: any, update: any) => void;
}

export const useAdditionalFieldsStore = create<IUseAdditionalFieldsStore>((set) => ({
  fields: [], // Поля
  append: () => {}, // Заглушки методов
  remove: () => {},
  update: () => {},
  setMethods: (fields: FieldType[], append: any, remove: any, update: any) => set({ fields, append, remove, update }),
}));
